/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { BEM } from "@adapptio/lib-components";
import { CodeEditor } from "@adapptio/lib-editor-ui";
import React, { useState } from "react";
import "./TabsEditor.scss";

export interface ITabsEditorProps {
	className?: string;
	descriptor: string;
	examples?: string;
}

export const TabsEditor: React.FC<ITabsEditorProps> = ({ className, descriptor, examples }) => {
	const baseClass = BEM("edt-tabs-editor");

	const [ active, setActive ] = useState(descriptor ? 1 : 2);

	const handleToogle = (e, idx: number) => {
		e.preventDefault();
		setActive(idx);
	};

	if (className) {
		baseClass.add(className);
	}

	return (
		<div className={baseClass.toClassName()}>
			<ul className={baseClass.element("tabs-wrap").toClassName()}>
				{descriptor && (
					<li className={baseClass.element("tab", { active: active === 1 }).toClassName()}>
						<a href="/" onClick={(e) => handleToogle(e, 1)}>
							Data Structure
						</a>
					</li>
				)}
				{examples && (
					<li className={baseClass.element("tab", { active: active === 2 }).toClassName()}>
						<a href="/" onClick={(e) => handleToogle(e, 2)}>
							Data Example
						</a>
					</li>
				)}
			</ul>

			{descriptor && (
				<div className={baseClass.element("tab-content", { active: active === 1 }).toClassName()}>
					<CodeEditor
						value={descriptor}
						language="adapptioExpression"
						readOnly={true}
						options={{
							minimap: { enabled: false },
							scrollBeyondLastLine: false,
							scrollBeyondLastColumn: 0,
							automaticLayout: true,
							tabSize: 2,
							lineNumbers: "off",
							lineDecorationsWidth: 0,
							readOnly: true,
							renderLineHighlightOnlyWhenFocus: true
						}}
					/>
				</div>
			)}

			{examples && (
				<div className={baseClass.element("tab-content", { active: active === 2 }).toClassName()}>
					<CodeEditor
						value={examples}
						language="adapptioExpression"
						readOnly={true}
						options={{
							minimap: { enabled: false },
							scrollBeyondLastLine: false,
							scrollBeyondLastColumn: 0,
							automaticLayout: true,
							tabSize: 2,
							lineNumbers: "off",
							lineDecorationsWidth: 0,
							readOnly: true,
							renderLineHighlightOnlyWhenFocus: true
						}}
					/>
				</div>
			)}
		</div>
	);
};
